import React from 'react';
import clsx from 'clsx';
import { IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEditorStore } from '../../store';
import { useProgram } from '../../../loyalty/ProgramContext';

const useStyles = makeStyles<Theme>(({ spacing, palette }) => ({
  root: {
    padding: spacing(0.2, 0),
  },
  activeLanguage: {
    '& $flag': {
      boxShadow: `0 0 0 2px ${palette.primary.main}`,
    },
  },
  flag: {
    borderRadius: 26,
    height: 26,
    width: 26,
  },
}));

/**
 * LanguageToolbar - Switches between program languages in the editor.
 */
export function LanguageToolbar(): React.ReactElement {
  const classes = useStyles();
  const { program } = useProgram();
  const locale = useEditorStore(state => state.locale);
  const setLocale = useEditorStore(state => state.setLocale);

  const languages = program.languages;

  if (languages.length <= 0) {
    return <></>;
  }

  return (
    <div className={classes.root}>
      {languages.map(language => (
        <IconButton
          key={language}
          className={clsx(language === locale ? classes.activeLanguage : null)}
          onClick={() => language !== locale && setLocale(language)}
        >
          <img
            className={classes.flag}
            src={`${BASE_PATH}/assets/template/assets/flags/${language}.svg`}
            alt={language}
          />
        </IconButton>
      ))}
    </div>
  );
}
